import { computed, ref, onMounted } from 'vue'
import { request } from '../../utils.js'
import useLoading from '../loading.js'

export default function useApplicationOptions() {
  const { isLoading, start, stop } = useLoading()
  const options = ref(null)

  async function fetchApplicationOptions() {
    start('application.options')
    options.value = await request('/application/options', {})
    stop('application.options')
  }

  onMounted(async () => await fetchApplicationOptions())

  return {
    options,
    applicationOptionsIsLoading: computed(() => isLoading('application.options'))
  }
}
